import { Routes } from '@angular/router';

export const profileRoutes: Routes = [
  {
    path: 'profile',
    loadComponent: () => import('./profile-page/profile-page').then((m) => m.ProfilePage),
  },
];